import Client from './Clients/AxiosClient';
var resource = '/api';

export default {
    login(userLogin) {
        return Client.post(`${resource}/login`, userLogin, {
            withCredentials: true, responseType: 'json'
          })
    },
    changeCredentials(userLogin) {
        return Client.post(`${resource}/changecredential`, userLogin, {
            withCredentials: true, responseType: 'json'
          })
    },
    adminlogout() {
        return Client.post(`${resource}/adminlogout`, {
            withCredentials: true, responseType: 'json'
          })
    },
    changePassword(changePassword) {
        return Client.post(`${resource}/resetpassword`, changePassword, {
            withCredentials: true, responseType: 'json'
          })
    },
    forgotPassword(changePassword) {
        return Client.post(`${resource}/forgotpassword`, changePassword, {
            withCredentials: true, responseType: 'json'
          })
    },    
    resetPassword(resetThePassword) {
        return Client.post(`${resource}/resetpassword`, resetThePassword, {
            withCredentials: true, responseType: 'json'
          })
    },    
    userIdPassword(userId) {
        //return Client.get(`${resource}/PatientCredentals/` + credentials, {                    
        return Client.get(`${resource}/UseridPassword/` + userId, {
            withCredentials: true, responseType: 'json'
          })
    },    
};